// Steps — mobile-only Swiper slider for the photo cards.
// Desktop (>= md / 768px) keeps the static 3-column grid (see block.scss); the
// slider is initialised ONLY below md on the live site and destroyed again when
// the viewport grows. It is never initialised inside the canvas editor, so the
// loop editor keeps a drag-editable grid there.

common.View.create('canvas.blocks.site.steps.Block', {

    onDOMLoad() {
        this.$slider = this.element.find('.site-steps-cards[data-steps-slider="true"]');
        if (!this.$slider.length || typeof Swiper === 'undefined') return;

        this.sliderEl = this.$slider[0];

        // Keep it a plain grid in the editor so editing/sorting works.
        if ($('body').hasClass('canvas-editor')) return;

        this.mq = window.matchMedia('(max-width: 767px)');
        this.onMqChange = () => this.syncSwiper();

        // Safari < 14 only has the deprecated addListener/removeListener.
        if (this.mq.addEventListener) {
            this.mq.addEventListener('change', this.onMqChange);
        } else {
            this.mq.addListener(this.onMqChange);
        }

        this.syncSwiper();
    },

    syncSwiper() {
        if (this.mq.matches) {
            this.initSwiper();
        } else {
            this.destroySwiper();
        }
    },

    initSwiper() {
        if (this.sliderEl.swiper) return;

        new Swiper(this.sliderEl, {
            slidesPerView: 1,
            spaceBetween: 16,
            watchOverflow: true,
            navigation: {
                prevEl: this.element.find('.site-steps-nav--prev')[0],
                nextEl: this.element.find('.site-steps-nav--next')[0],
            },
            a11y: {
                prevSlideMessage: 'Vorige stap',
                nextSlideMessage: 'Volgende stap',
            },
        });
    },

    destroySwiper() {
        if (this.sliderEl.swiper && typeof this.sliderEl.swiper.destroy === 'function') {
            // destroy(deleteInstance, cleanStyles) — cleanStyles reverts the
            // wrapper/slides to plain elements so the desktop grid CSS applies.
            this.sliderEl.swiper.destroy(true, true);
        }
    },

});
